// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"Skeleton_skeleton__1e5QL","dark":"Skeleton_dark__3dwVc","productCardSkeleton":"Skeleton_productCardSkeleton__2pg1x","shine":"Skeleton_shine__1Zq1x"};